import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import CenterService from '../../../services/centers/center.service.js'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions.js'
import DataTableComp from '../../../components/common/data-table/DataTableComp.jsx'

import dayjs from 'dayjs'
import { urlBack } from './utils/center.utils.ts'
import { useDisclosure } from '@mantine/hooks'
import { Checkbox, Group } from '@mantine/core'
import CenterSection from './common/CenterSection.tsx'
import AppButton from '../../../component/common/AppButton.tsx'
import AppIcon from '../../../component/common/AppIcon.tsx'
import { useTranslation } from 'react-i18next'
import AppNumberFormatter from '../../../component/data/AppNumberFormatter.tsx'
import { collections } from '../../../config/app.ts'
import AppCheckbox from '../../../component/form/AppCheckbox.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'

const CenterCashRegisters = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [currentCenter, setCurrentCenter] = useState()
  const [selectedRowId, setSelectedRowId] = useState()

  const navigate = useNavigate()

  useEffect(() => {
    getCenterData()
  }, [])

  // useEffect(() => {
  //     if (!isShowing) dataFacade?.reload()
  // }, [isShowing])

  const getCenterData = async () => {
    if (id && id !== 'undefined') {
      const response = await CenterService.getById(id)
      if (response) {
        setCurrentCenter(response.resp)
      }
    }
  }

  const dataFacade = useHandlerBasicActions({
    // sortFieldInitial: 'comercialDataId',
    getAll: ({ filter, sort, limit, skip }) =>
      CenterService?.cashRegisters?.getAll({ id, filter, sort, limit, skip }),
  })

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const renderWeather = (rowData) => (
    <Group w="100%" justify="flex-end">
      {t(rowData?.dailyStatus?.weather)}
      {
        <AppIcon
          icon={collections?.weather?.[rowData?.dailyStatus?.weather]?.icon}
          color={collections?.weather?.[rowData?.dailyStatus?.weather]?.color}
        />
      }
      {/* {rowData?.dailyStatus?.weather==='SUNNY' && <AppIcon icon="sunny" color="orange" />}
            {rowData?.dailyStatus?.weather==='CLOUDY' && <AppIcon icon="cloudy" color="lightsteelblue" />}
            {rowData?.dailyStatus?.weather==='SUNNY_CLOUDY' && <AppIcon icon="sunnyCloudy" color="dodgerblue" />}
            {rowData?.dailyStatus?.weather==='SNOWY' && <AppIcon icon="snowy" color="deepskyblue" />}
            {rowData?.dailyStatus?.weather==='RAINY' && <AppIcon icon="rainy" color="darkgray" />} */}
    </Group>
  )

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        editMode: 'row',
        selectionMode: 'single',
        selection: selectedRowId,
        onRowSelect: (e) => {
          console.log(e?.data?._id)
          setSelectedRowId(e?.data?._id)
          navigate(`/app/centers/${id}/cash-registers/edit?id=${e?.data?._id}`)
        },
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column
          sortable
          field="dailyStatus.date"
          header={t('date')}
          style={{ minWidth: '120px', width: '120px' }}
          body={(rowData) =>
            dayjs(new Date(rowData?.dailyStatus?.date)).format('DD/MM/YYYY')
          }
        />,
        <Column
          sortable
          field="dailyStatus.weather"
          header={t('weather')}
          align="right"
          style={{ minWidth: '160px', width: '40%' }}
          body={(rowData) => renderWeather(rowData)}
        />,
        <Column
          sortable
          field="dailyStatus.isClosed"
          align="right"
          header={t('closed')}
          style={{ minWidth: '140px', width: '140px' }}
          body={(rowData) =>
            rowData?.dailyStatus?.isClosed ? (
              <Group w="100%" justify="flex-end" c="red.8">
                {t('closed')}
                <AppIcon icon="locked" />
              </Group>
            ) : (
              <Group w="100%" justify="flex-end" c="green.2">
                <AppIcon icon="unlocked" />
              </Group>
            )
          }
        />,
        <Column
          sortable
          className="divider"
          field="trackSales"
          align="right"
          header={t('tracks')}
          style={{ minWidth: '140px', width: '40%' }}
          body={(rowData) => (
            <AppNumberFormatter value={rowData?.totals?.tracks} suffix="€" />
          )}
        />,
        <Column
          sortable
          field="aspiratorSales"
          align="right"
          header={t('aspirators')}
          style={{ minWidth: '140px', width: '140px' }}
          body={(rowData) => (
            <AppNumberFormatter value={rowData?.totals?.tracks} suffix="€" />
          )}
        />,
        <Column
          sortable
          field="totals.sales"
          align="right"
          header={t('sales')}
          style={{ minWidth: '140px', width: '140px' }}
          body={(rowData) => (
            <AppNumberFormatter value={rowData?.totals?.sales} suffix="€" />
          )}
        />,
        <Column
          sortable
          className="divider"
          field="totals.theoreticalCashBalance"
          align="right"
          header={t('theoreticalCashBalance')}
          style={{ minWidth: '160px', width: '40%' }}
          body={(rowData) => (
            <AppNumberFormatter
              value={rowData?.totals?.theoreticalCashBalance}
              suffix="€"
            />
          )}
        />,
        <Column
          sortable
          field="totals.cashBalance"
          align="right"
          header={t('cashBalance')}
          style={{ minWidth: '180px', width: '180px' }}
          bodyClassName={(rowData) =>
            rowData?.totals?.theoreticalCashBalance !==
            rowData?.totals?.cashBalance
              ? 'text-danger'
              : 'text-success'
          }
          body={(rowData) => (
            <Group w="100%" h="100%" justify="flex-end">
              <AppNumberFormatter
                value={rowData?.totals?.cashBalance}
                suffix="€"
              />
            </Group>
          )}
        />,
        // <Column
        //     sortable
        //     field="totals.pulses"
        //     align="right"
        //     header={t("pulses")}
        //     body={(rowData) => <AppNumberFormatter value={rowData?.totals?.pulses} />}
        // />,
      ]}
    />
  )

  return (
    <CenterSection
      toolbar={
        <AppToolbar
          rightSection={[
            <AppButton
              preset="back"
              onClick={() => navigate(urlBack(currentCenter?.centerType))}
            />,
            <AppButton
              preset="add"
              onClick={() => {
                // setSelectedRowId()
                navigate(`/app/centers/${id}/cash-registers/edit`)
              }}
            />,
          ]}
        />
      }
    >
      {dataTable}
    </CenterSection>
  )
}

export default CenterCashRegisters
